import React from "react";
import { createSearchParams, Navigate, NavigateFunction, RouteObject } from "react-router-dom";
import { Autopig, Autopig_settings, Freeda_lf, Freeda_lf_sections, Freeda_lf_settings } from "../../../Containers"
import { SystemMenu_Pages } from "../../pages";
import { TabMenu } from "../../Menus";

// TODO
import { default as Freeda_esf_settings } from "../../../Containers/FullViewScreens/SystemScreens/Freeda_esf/freeda_esf_settings";
import { default as Freeda_esf_sections } from "../../../Containers/FullViewScreens/SystemScreens/Freeda_esf/freeda_esf_sections";
import { default as Freeda_esf } from "../../../Containers/FullViewScreens/SystemScreens/Freeda_esf/freeda_esf";

export const Router = [
    { path:`/${SystemMenu_Pages.autopig}/:systemId`, element:<TabMenu main={SystemMenu_Pages.autopig} overrides={{base_alternative:SystemMenu_Pages.home}} contexts={[ SystemMenu_Pages.Autopig_settings ]} />,
      children:[
        { index:true, Component:Autopig },
        { path: `${SystemMenu_Pages.Autopig_settings}`, Component:Autopig_settings },
        { path: `*`, element: <Navigate to={`/${SystemMenu_Pages.autopig}`} />}
      ]
    },
    { path:`/${SystemMenu_Pages.freeda_lf}/:systemId`, element:<TabMenu main={SystemMenu_Pages.freeda_lf} overrides={{base_alternative:SystemMenu_Pages.home}} contexts={[ SystemMenu_Pages.freeda_lf_sections, SystemMenu_Pages.freeda_lf_settings ]} />,
      children:[
        { index:true, Component:Freeda_lf },
        { path:`${SystemMenu_Pages.freeda_lf_sections}`, Component:Freeda_lf_sections },
        { path:`${SystemMenu_Pages.freeda_lf_settings}`, Component:Freeda_lf_settings }
      ]
    },
    { path:`/${SystemMenu_Pages.freeda_esf}/:systemId`, element:<TabMenu main={SystemMenu_Pages.freeda_esf} overrides={{base_alternative:SystemMenu_Pages.home}} contexts={[ SystemMenu_Pages.freeda_esf_sections, SystemMenu_Pages.freeda_esf_settings ]} />,
    children:[
      { index:true, Component:Freeda_esf },
      { path:`${SystemMenu_Pages.freeda_esf_sections}`, Component:Freeda_esf_sections },
      { path:`${SystemMenu_Pages.freeda_esf_settings}`, Component:Freeda_esf_settings }
    ]
  },
  ] as RouteObject[]

export const NavigationFunction = (Navigator: NavigateFunction, navigation_page: SystemMenu_Pages, navigation_tab?: SystemMenu_Pages, navArgs?: Object, currentDomain?: string) => {
  const selected = navArgs && "selected" in navArgs && typeof navArgs.selected === "number" && navArgs.selected ? navArgs.selected : 0;
  const systemIdFromParams = navArgs && "systemId" in navArgs && typeof navArgs.systemId === "string" && navArgs.systemId ? navArgs.systemId : undefined;
  const systemId = systemIdFromParams ? systemIdFromParams : selected;
  const search = currentDomain ? createSearchParams({domain: currentDomain }).toString() : undefined;
  const navigation = systemIdFromParams ? {selected: +systemId} : navArgs;

  switch (navigation_page) {
    case SystemMenu_Pages.home:
      Navigator(SystemMenu_Pages.home, {state:{}})
    break
    case SystemMenu_Pages.autopig:
      switch (navigation_tab) {
        case SystemMenu_Pages.Autopig_settings:
          Navigator({pathname: `/${SystemMenu_Pages.autopig}/${SystemMenu_Pages.Autopig_settings}`, search}, {state:{tab:1, ...navigation}})
        break
        default: Navigator({pathname: `/${SystemMenu_Pages.autopig}`, search}, {state:{tab:0, ...navigation}})
      }
    break
    case SystemMenu_Pages.freeda_lf:
      switch (navigation_tab) {
        case SystemMenu_Pages.freeda_lf_sections:
          Navigator({pathname: `/${SystemMenu_Pages.freeda_lf}/${systemId}/${SystemMenu_Pages.freeda_lf_sections}`, search}, {state:{tab:1, params:{...navigation}}})
        break
        case SystemMenu_Pages.freeda_lf_settings:
          Navigator({pathname: `/${SystemMenu_Pages.freeda_lf}/${systemId}/${SystemMenu_Pages.freeda_lf_settings}`, search}, {state:{tab:2, params:{...navigation}}})
        break
        default: Navigator({pathname: `/${SystemMenu_Pages.freeda_lf}/${systemId}`, search}, {state:{tab:0, ...navigation}})
      }
      break
      case SystemMenu_Pages.freeda_esf:
        switch (navigation_tab) {
          case SystemMenu_Pages.freeda_esf_sections:
            Navigator({pathname: `/${SystemMenu_Pages.freeda_esf}/${SystemMenu_Pages.freeda_esf_sections}`, search}, {state:{tab:1, ...navigation}})
          break
          case SystemMenu_Pages.freeda_esf_settings:
            Navigator({pathname: `/${SystemMenu_Pages.freeda_esf}/${SystemMenu_Pages.freeda_esf_settings}`, search}, {state:{tab:2, ...navigation}})
          break
          default: Navigator({pathname: `/${SystemMenu_Pages.freeda_esf}/${systemId}`, search}, {state:{tab:0, ...navigation}})
        }
      break
    default:
      console.log("Error page not found (404)???, [SystemMenu]")
  }
}